import { render, staticRenderFns } from "./ImportStatistics.vue?vue&type=template&id=6778556e&scoped=true"
import script from "./ImportStatistics.vue?vue&type=script&lang=js"
export * from "./ImportStatistics.vue?vue&type=script&lang=js"
import style0 from "./ImportStatistics.vue?vue&type=style&index=0&id=6778556e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6778556e",
  null
  
)

export default component.exports